import "select2/dist/js/i18n/fr";

$(document).ready(function () {
  $('#autopublish_locality').select2({
    minimumInputLength: 3,
    language: 'fr',
    ajax: {
      url: function() {
        return `/admin/countries/${$('#autopublish_country').val()}/localities.json`
      },
      data: function (params) {
        var query = {search: params.term}
        return query;
      },
      processResults: function (data) {
        console.log(data)
        // Transforms the top-level key of the response object from 'items' to 'results'
        return {
          results: data.map(item => ({
            id: item.id,
            text: `${item?.department_number ? `${item.department_number} - ` : ''}${item?.name}`
          }))
        };
      }
    }
  })

  $('#autopublish_country').change(function () {
    $('#autopublish_locality').val('').trigger('change')
  })
})
